// extracted by mini-css-extract-plugin
module.exports = {"testChannelIconWrapper":"ControlGroupIcon-testChannelIconWrapper-1Ykfbl","testChannelIcon":"ControlGroupIcon-testChannelIcon-IsMoP1"};